import { type FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';

export const useIsFeatureEnabled = (splitName: FEATURE, treatment = 'on') => {
  const { treatments } = useTreatments([splitName]);
  return treatments[splitName]?.treatment === treatment;
};
